<ng-container *ngIf="{noteAttachment: (noteAttachmentState$ | async)} as state">
  <div
    *ngIf="isNoteLoaded(state); else loader"
    class="row no-gutters item"
    [ngClass]="{'no-padding': !!sideDrawerConfiguration}"
  >
    <common-mojo-avatar
      [backgroundSize]="avatarBackground"
      [id]="author?.photoId"
      [initials]="author?.firstName[0] + author?.lastName[0]"
      [selectedPhotoShape]="avatarPhotoShape"
    ></common-mojo-avatar>
    <div
      class="notes-content"
      [ngClass]="{'side-drawer-container': !!sideDrawerConfiguration}"
    >
      <div class="notes-header">
        <div class="wrap">
          <span
            class="label"
            *ngIf="labelTxt"
            [matTooltip]="getVisibleToText(note?.teamMembers)"
            [matTooltipDisabled]="(!note?.teamMembers || note?.teamMembers.length === 0)"
            matTooltipPosition="above"
            matTooltipClass="note-visibility-tooltip"
          >
            {{labelTxt}}
          </span>
          <span
            class="label label-draft"
            *ngIf="note?.category === draft"
          >
            DRAFT
          </span>
        </div>

        <div
          class="author"
          [ngClass]="{
          'is-author': isAuthor(user$ | async),
          'fullpage': fullpage
          }"
        >
          <h5>{{ author?.name }}</h5>
          <div class="date-and-menu">
            <span
              class="grey-out">{{ note.lastModifiedDate | date: 'short' }}</span>
            <mojo-notes-options
              (deleteNoteClicked)="deleteNote()"
              (editNoteClicked)="openEditModal()"
              *ngIf="isAuthor(user$ | async)"
            >
            </mojo-notes-options>
          </div>
        </div>
      </div>

      <div>
        <div class="flexDisplay">
          <mojo-mentions-text-converter
            [note]="note"
            [greyOut]="true"
            [textToConvert]="note?.title"
          ></mojo-mentions-text-converter>
        </div>
      </div>
      <mojo-mentions-text-converter
        [note]="note"
        [textToConvert]="note?.content"
      ></mojo-mentions-text-converter>
      <div *ngIf="!!note?.attachments && note?.attachments?.length > 0">
        <div
          *ngIf="!fullpage"
          class="attachments"
        >
          <div
            [routerLink]="['notes']"
            class="small-attachment attachment-item"
          >
            <mat-icon>attach_file</mat-icon>&nbsp;{{note?.attachments.length}}
          </div>
        </div>
        <div
          *ngIf="fullpage"
          class="attachments"
        >
          <div
            class="attachment-item fullpage-attachment"
            *ngFor="let attachment of note?.attachments"
          >
            <mat-icon>attach_file</mat-icon>
            <div class="file-details">

              <a (click)="getUrl(attachment.id)">
                <span
                  matTooltip="{{attachment?.name}}"
                  matTooltipClass="attachment-tooltip"
                >{{getFileNameWithoutExtension(attachment?.name)}}
                </span>
              </a>
              <span
                class="file-extension">{{getExtension(attachment?.name)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loader>
  <mojo-loader></mojo-loader>
</ng-template>
